<dms-control [dmsTraduction]="this.dmsTraduction" >
	<div class="input-group mail">
		<input class="mail form-control" type="email" [(ngModel)]="address" >
		<span class="input-group-btn">
			<button class="btn btn-primary" type="button" (click)="sendMail()" title="Envoyer mail">
				<i class="fa fa-envelope" style="width: 11px" ></i>
			</button>
		</span>
	</div>
</dms-control>